module.exports = __webpack_public_path__ + "ic-edit-lined.svg?568113a1588115b1efe1facae390574c";